import RootFieldBuilder from './root.js';
class SubscriptionFieldBuilder extends RootFieldBuilder {
    constructor(builder) {
        super("Subscription", builder, "Subscription", "Object");
    }
}
export { SubscriptionFieldBuilder as default };
//# sourceMappingURL=subscription.js.map
